import React from 'react'

const LowerContent = () => (
  <div className="instruction">
    <div>
      <span>Lifetime Replacement Return Instructions</span>
    </div>
    <div className="step-container">
      <div>
        <div className="bullet">
          <div className="step">
            <p>
              <span>Step 1: Print</span>
            </p>
            <p>
              <span>
                To expedite your refund process,&nbsp;
                please print out this Lifetime Replacement Packing Slip to&nbsp;
                include in your return package.
              </span>
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className="bullet">
          <div className="step">
            <p>
              <span>Step 2: Package</span>
            </p>
            <p>
              <span>
                Please pack the original part and this Packing Slip into a box.
              </span>
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className="bullet">
          <div className="step">
            <p>
              <span>Step 3: Ship</span>
            </p>
            <p>
              <span>
                Please ship your package to&nbsp;
                <span>
                  CarParts.com 1301 Ave T, Grand Prairie, TX, 75050
                </span>
                &nbsp;using your preferred shipping carrier.
              </span>
            </p>
            <p>
              <span>
                Prior to shipping, please make&nbsp;
                sure you have purchased your replacement&nbsp;
                part on CarParts.com.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default LowerContent
